import { useContext } from 'react';
import {
  GovernanceTagsProcessingContext,
  GovernanceTagsProcessingContextType,
} from '../contexts/governanceTagsProcessingContext.ts';

export const useGovernanceTagsProcessing = (): GovernanceTagsProcessingContextType => {
  const context = useContext(GovernanceTagsProcessingContext);
  if (!context) {
    throw new Error('useGovernanceTagsProcessing must be used within a GovernanceTagsProcessingProvider');
  }
  return context;
};
